/* eslint-disable */
import React, { useContext, useMemo, useRef, useState } from 'react';
import { Button, DropdownButton, MenuItem } from 'react-bootstrap';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { ServicesDeletedContext } from '../../../index';
import TableMassActions from '../../../../../../components/Table/MassActions';
import ServicesDropdown from '../../../../../../components/Dropdown/ServicesDropdown';
import { Head, Row, Cell } from '../../../../../../components/Table/Grid';

import { getType } from '../../../../../../utils/services';
import { DropdownIndicator, ClearIndicator } from '../../../../Main/components/Listing/Table/Header';
import * as modals from '../../../constants/modals'

import {
  changeFilterProvider,
  changeFilterType,
  checkedMassAdd,
  checkedMassDelete,
  modalOpen,
  tableSort,
} from '../../../reducer';
import { getSortColumnByName } from '../../../../../../utils/helper';
import SortIcon from '../../../../../../components/Table/SortIcon';

const massActions = [
  {
    accessKey: 'change_service_status',
    title: 'Restore all',
    value: 'RESTORE_ALL',
  },
]

export const createProviderSelected = (providers, providersSelected) => {
  if (providers?.length && providersSelected) {
    return providersSelected
      .reduce((accumulator, currentValue) => {
        const provider = [{id: 6, name: "Manual"}, ...providers].find((provider) => provider.id === Number(currentValue));
        if (provider) {
          accumulator.push(
            {
              id: provider.id,
              label: provider.name,
              value: provider.id,
            }
          )
        }
        return accumulator;
      }, [])
  }
  return []
}

export const getProviderOptions = (providers) => {
  const providersList = providers.map((provider) => ({
    id: provider.id,
    value: provider.id,
    label: provider.name,
  }));
  return [{
    id: 6,
    value: 6,
    label: "Manual"
  }, ...providersList]
}

const ServicesDeletedTableHeader = () => {
  const { darkMode } = useSelector((state) => state.general);
  const [store, dispatch] = useContext(ServicesDeletedContext);
  const { isLoadingTable, configuration, types, sort, checked, filters, providers } = store;

  const providerOptions = useMemo(() => getProviderOptions(providers), [providers])
  const providersSelected = useMemo(() => createProviderSelected(providers, filters.providers), [providers, filters.providers])

  const showProviderColumn = configuration.access.see_provider_column;
  const dropdownNode = useRef(null);
  const [isOpenProviders, setOpenProviders] = useState(false);
  const outSideClickProviders = (e) => {
    if (dropdownNode.current && dropdownNode.current.contains(e.target)) {
      return false;
    }
    document.removeEventListener('mousedown', outSideClickProviders, false);
    return setOpenProviders(false);
  };

  const onOpenProviders = () => {
    if (isOpenProviders) {
      document.removeEventListener('mousedown', outSideClickProviders, false);
      setOpenProviders(false);
    } else {
      document.addEventListener('mousedown', outSideClickProviders, false);
      setOpenProviders(true);
    }
  };

  const onChangeProvider = (selectProviders) => {
    const newProvidersFilter = selectProviders.map((provider) => provider.id);
    dispatch(changeFilterProvider(newProvidersFilter.length ? newProvidersFilter : null))
  }

  const isCheckedMassAction = !!checked.length;
  const onChangeMassCheckbox = () => {
    if (isCheckedMassAction) {
      dispatch(checkedMassDelete())
      return;
    }
    dispatch(checkedMassAdd())
  }
  const onChangeMassAction = () => {
    const name = modals.RESTORE_ALL;
    const data = {
      services: checked,
    }
    dispatch(modalOpen(name, data))
  }

  const filterType = useMemo(() => getType(types, filters.type), [types, filters.type]);
  const typeBtnName = filterType?.name ? filterType.name : 'Type';
  const onChangeFilterType = (typeId) => {
    if (filters.type === typeId) {
      return;
    }
    dispatch(changeFilterType(typeId))
  }

  const sortId = useMemo(() => getSortColumnByName(sort.columns, 'id'), [sort.columns])
  const sortDeletedAt = useMemo(() => getSortColumnByName(sort.columns, 'deleted_at'), [sort.columns])
  const onChangeSort = (sortColumn) => {
    const srt = sortColumn.active === 'asc' ? sortColumn.desc : (sortColumn.active === 'desc' ? sortColumn.asc : sortColumn.asc)
    dispatch(tableSort(srt))
  }

  return (
    <Head bg>
      <Row>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 42, width: 42 }}>
          <div className="d-flex justify-center">
            <TableMassActions
              count={checked.length}
              counterTitle="services"
              checked={isCheckedMassAction}
              disabled={isLoadingTable}
              onChange={onChangeMassCheckbox}
            >
              <ServicesDropdown id="mass-actions" handleSelect={onChangeMassAction} bsSize="xsmall" title="Actions" items={massActions} />
            </TableMassActions>
          </div>
        </Cell>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 50, width: 50 }} bold>
          <span onClick={() => onChangeSort(sortId)} className="cursor-pinter">
            ID
            {' '}
            <SortIcon sortObj={sortId} />
          </span>
        </Cell>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 325 }} bold>Service</Cell>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 190 }} bold>
          {types.length ? (
            <DropdownButton
              bsStyle="default"
              title={typeBtnName}
              className={classNames('service-table__filter-btn', {
                active: false,
              })}
              id="dropdown-filter-type"
            >
              <MenuItem active={filters.type === null} onClick={() => onChangeFilterType(null)}>
                All
              </MenuItem>
              {types.map((type) => (
                <MenuItem key={type.id} eventKey={type.id} active={type.id === filters.type} onClick={() => onChangeFilterType(type.id)}>
                  {type.name}
                </MenuItem>
              ))}
            </DropdownButton>
          ) : (
            'Type'
          )}
        </Cell>
        {showProviderColumn
          ? (
            <Cell height="md" borderBottom="xs" style={{ minWidth: 170 }} bold>
              {providers.length ? (
                <div className="service-table__provider-dropdown" ref={dropdownNode}>
                  <Button
                    className="service-table__filter-btn"
                    onClick={onOpenProviders}
                    active={!!filters.providers}
                    id="dropdown-filter-provider"
                  >
                    Provider
                    {' '}
                    {filters.providers?.length ? `(${filters.providers.length}) ` : null}
                    <span className="caret" />
                  </Button>
                  {isOpenProviders ? (
                    <div className="service-table__provider-dropdown-menu">
                      <Select
                        autoFocus
                        menuIsOpen
                        isMulti
                        components={{ DropdownIndicator, ClearIndicator, IndicatorSeparator: null }}
                        onChange={onChangeProvider}
                        noOptionsMessage={() => 'No providers'}
                        controlShouldRenderValue={false}
                        hideSelectedOptions={false}
                        value={providersSelected}
                        options={providerOptions}
                        styles={{
                          container: (styles) => ({
                            ...styles,
                            width: '270px',
                            border: '1px solid rgba(0,0,0,.15)',
                            background: darkMode ? '#222327' : '#ffffff',
                            borderRadius: '4px',
                            paddingTop: '7px',
                            paddingLeft: '7px',
                            paddingRight: '7px',
                            boxShadow: '0 6px 12px rgba(0,0,0,.175)',
                          }),
                          valueContainer: (styles) => ({
                            ...styles,
                            paddingTop: '2px',
                            paddingBottom: '2px',
                            paddingLeft: '0px',
                            paddingRight: '8px',
                          }),
                          menu: (styles) => ({
                            ...styles,
                            marginTop: '0px',
                            boxShadow: 'none',
                            border: 'none',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            position: 'relative',
                            background: darkMode ? '#222327' : '#ffffff',
                          }),
                          input: (styles) => ({
                            ...styles,
                            color: darkMode ? '#dfe0e1' : '#333',
                          }),
                          control: (styles) => ({
                            ...styles,
                            minHeight: '34px',
                            flexDirection: 'row-reverse',
                            borderBottomWidth: '1px',
                            border: darkMode ? 'inset 0 2px 4px 0 rgb(0 0 0 / 20%)' : '1px solid #ddd',
                            boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
                            cursor: 'text',
                            color: darkMode ? '#dfe0e1' : '#333',
                            background: darkMode ? '#2e3036' : '#ffffff',
                            borderColor: 'rgba(103, 107, 118, 0.5)',
                            '&:hover': {
                              border: darkMode ? 'solid 1px rgba(103, 107, 118, 0.5)' : '1px solid #ccc',
                            },
                          }),
                          // eslint-disable-next-line no-unused-vars
                          option: (styles, { data, isSelected }) => ({
                            ...styles,
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            paddingTop: '3px',
                            paddingBottom: '3px',
                            cursor: 'pointer',
                            color: darkMode ? '#dfe0e1' : '#333',
                            background: darkMode ? '#222327' : '#ffffff',
                            '&:hover': {
                              background: darkMode ? '#2e3036' : '#f5f5f5',
                            },
                            '&:before': isSelected
                              ? {
                                content: '"\\e013"',
                                fontFamily: 'Glyphicons Halflings',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                position: 'absolute',
                                right: '4px',
                              }
                              : null,
                          }),
                        }}
                        getOptionLabel={(option) => `${option.label}`}
                        placeholder="Search"
                      />
                    </div>
                  ) : null}
                </div>
              ) : (
                'Provider'
              )}
            </Cell>
          ) : null}
        <Cell height="md" borderBottom="xs" style={{ minWidth: 95 }} bold>Rate</Cell>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 120 }} bold>
          <span onClick={() => onChangeSort(sortDeletedAt)} className="cursor-pinter">
            Deleted at
            {' '}
            <SortIcon sortObj={sortDeletedAt} />
          </span>
        </Cell>
        <Cell height="md" borderBottom="xs" style={{ minWidth: 100 }} />
      </Row>
    </Head>
  );
};

ServicesDeletedTableHeader.propTypes = {

};

export default ServicesDeletedTableHeader;
